import { render, staticRenderFns } from "./FavoritePhrase.vue?vue&type=template&id=21ed09ba&scoped=true"
import script from "./FavoritePhrase.vue?vue&type=script&lang=js"
export * from "./FavoritePhrase.vue?vue&type=script&lang=js"
import style0 from "./FavoritePhrase.vue?vue&type=style&index=0&id=21ed09ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ed09ba",
  null
  
)

export default component.exports